/* eslint-disable */

export enum Role {
  DO_NOT_USE = "DO_NOT_USE",
  /**
   * SENDER - The person whose account is debited. For cash@ payments this is the
   * cash initiator. For bill@ payments it is the bill getter.
   */
  SENDER = "SENDER",
  /**
   * RECIPIENT - The person whose account is credited. For cash@ payments this is the
   * cash getter. For bill@ payments it is the bill initiator.
   */
  RECIPIENT = "RECIPIENT",
}
